module.exports = __webpack_public_path__ + "img/india.8186e551.jpg";